exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-img[data-v-6b92339a] {\n  max-height: 40px;\n.font-awesome {\n    height: 14px;\n    width: 14px;\n}\n}\n", ""]);

// exports
